import Class from './c-contructor-tab';
import './c-contructor-tab@.vue';

export default Class;